<template>
  <section>
    <b-modal
      :active="show"
      @close="closeModalItems"
      has-modal-card
    >
      <div class="modal-card lr-modal-items">
        <header class="modal-card-head">
          <b-icon
          icon="eye-outline"
          size="is-small"
        />
        <div
          class="lr-modal-title"
          v-t="$t('ModalItems.title', { orderID: showID })"
        />
        </header>
        <section
          class="modal-card-body"
        >
          <div class="columns local-lm-modal">
            <b-table
              :data="allItems"
              class="local-lm-modal-items"
            >
              <b-table-column
                field="id"
                v-slot="props"
                :label="$t('ModalItems.tableColumn1')"
              >
                <div>
                  {{ props.row.itemID }}
                </div>
              </b-table-column>
              <b-table-column
                field="id"
                v-slot="props"
                :label="$t('ModalItems.tableColumn2')"
              >
                <div>
                  {{ props.row.barCode }}
                </div>
              </b-table-column>
              <b-table-column
                field="id"
                v-slot="props"
                :label="$t('ModalItems.tableColumn3')"
              >
                <div>
                  {{ props.row.itemLabel }}
                </div>
              </b-table-column>
              <b-table-column
                field="id"
                v-slot="props"
                :label="$t('ModalItems.tableColumn4')"
              >
                <div>
                  {{ props.row.quantity }}
                </div>
              </b-table-column>
              <b-table-column
                field="id"
                v-slot="props"
                :label="$t('ModalItems.tableColumn5')"
              >
                <div>
                  {{ $t(`ModalItems.${props.row.lineStatus}`) }}
                </div>
              </b-table-column>
            </b-table>
          </div>
        </section>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalItems',
  computed: {
    ...mapGetters('items', [
      'show',
      'allItems',
      'showSupplierOrderCode'
    ]),
    showID () {
      return this.showSupplierOrderCode
    }
  },
  watch: {
    show: {
      handler: function (changes) {
        // ! everytime changed the modal visibility check if the closeModal event has fired
        if (changes) {
          this.$eventBus.$on('closeModal', () => {
            this.closeModalItems()
          })
        }
      },
      deep: true
    }
  },
  methods: {
    closeModalItems () {
      this.$store.dispatch('items/disable')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalItems.vue